import React, { createContext, useReducer, useContext, useCallback, useEffect,useState, useRef } from 'react';
import axiosUserInstance from '../../../axiosUserInstance';
const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
const FLUSH_NOTIFICATIONS = 'FLUSH_NOTIFICATIONS';
const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
const MARK_ALL_AS_READ='MARK_ALL_AS_READ';
const NotificationContext = createContext();

function notificationReducer(state, action) {
    switch (action.type) {
    case ADD_NOTIFICATION:
        return [...state, action.payload];
    case REMOVE_NOTIFICATION:
        return state.filter((notification) => notification.id !== action.payload);
    case FLUSH_NOTIFICATIONS:
        return [];
    case UPDATE_NOTIFICATION:
        return state.map((notification) =>
            notification.id === action.payload.id ? { ...notification, ...action.payload.data } : notification
        ); 
    case MARK_ALL_AS_READ:
        return state.map((notification) => ({ ...notification, is_read: true }));// Clear all notifications
    default:
        return state;
    }
}

export function NotificationProvider({ children }) {
    const [notifications, dispatch] = useReducer(notificationReducer, []);
    const [notificationCountvalue, setNotificationCount] = useState(0);
    const [shipdayResponse, setShipdayResponse] = useState(null);

    const[notifcationvalue,setNotificationValue]=useState();
    const prevNotificationLength = useRef(0);
    // Add a new notification with extra action data if needed
    const updateShipdayResponse = useCallback((data) => {
        setShipdayResponse(data);
    }, []);

    const playNotificationSound = () => {
        const audio = new Audio('/sounds/notification.mp3');
        audio.volume = 1.0;
        audio.play().catch((e) =>
            console.error('🔕 Failed to play notification sound:', e)
        );
    };
    
    const fetchNotifications = async () => {
        try {
            const res = await axiosUserInstance.get('/notifications/notifications');
            if (res.status === 200) {
                const fetchedNotifications = res?.data?.notifications || [];

                // 🔔 Play sound if new notification arrived
                if (fetchedNotifications.length > prevNotificationLength.current) {
                    playNotificationSound();
                }

                prevNotificationLength.current = fetchedNotifications.length;

                dispatch({ type: ADD_NOTIFICATION, payload: fetchedNotifications });
                setNotificationCount(res?.data?.notificationCount);
                setNotificationValue(res?.data?.notifications);
                
                return fetchedNotifications;
                
            }
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, 5000);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         fetchNotifications();
    //     }, 5000); // Polling every 5 seconds
    //     return () => clearInterval(interval);
    // }, [fetchNotifications]);
    
    const addNotification = useCallback(async (notification) => {
    // Ensure each notification has a unique id
        // eslint-disable-next-line no-unused-vars
        const id = notification.id || Date.now();
        const notificationPayload = { ...notification };

        // First, dispatch to update the local state
        dispatch({ type: ADD_NOTIFICATION, payload: notificationPayload });

        try {
            const response = await axiosUserInstance.post('/notifications/create', notificationPayload);
            if (response.status === 200 || response.status === 201) {
                fetchNotifications();
                setNotificationCount(notificationCountvalue + 1);
                
            } else {
                console.error('Error creating notification on the server:', response);
            }
        } catch (error) {
            console.error('Error sending notification to API:', error);
        }
    }, []);
    
    const updateNotificationStatus = useCallback(async (currentUserId, type, id) => {
        try {
            const updateUrl = `/notifications/notifications/singlenotificationstatus?uid=${currentUserId}&type=${type}&id=${id}`;
    
            const response = await axiosUserInstance.put(updateUrl, { is_read: true });
    
            if (response.status === 200) {
                dispatch({
                    type: UPDATE_NOTIFICATION,
                    payload: { id, data: { is_read: true } }
                });
                setNotificationCount((prevCount) => Math.max(prevCount - 1, 0));
                fetchNotifications();
            }
        } catch (error) {
            console.error(`Error updating notification ${id}:`, error);
        }
    }, []);
    
    const markAllAsRead = useCallback(async (currentUserId, role) => {
        try {
            const updateUrl = `/notifications/notifications/status?uid=${currentUserId}&role=${role}`;
            await axiosUserInstance.put(updateUrl, { is_read: true });

            dispatch({ type: MARK_ALL_AS_READ });
            setNotificationCount(0);
            fetchNotifications();
        } catch (error) {
            console.error('Error marking all notifications as read:', error);
        }
    }, []);
    const removeNotification = useCallback(async (currentUserId, role) => {
        try {
            const deleteUrl = `/notifications/notifications/read?uid=${currentUserId}&role=${role}`;
            await axiosUserInstance.delete(deleteUrl);

            dispatch({ type: REMOVE_NOTIFICATION, payload: currentUserId });
            setNotificationCount(0); 
            fetchNotifications();
        } catch (error) {
            console.error(`Error deleting notification with ID: ${currentUserId}`, error);
        }
    }, []);


    const flushNotifications = useCallback(() => {
        if (notifications.length > 0) {
            console.log('Flushing notifications:', notifications);
            dispatch({ type: FLUSH_NOTIFICATIONS });
        } else {
            console.log('No notifications to flush.');
        }
    }, [notifications]);

    useEffect(() => {
        const interval = setInterval(() => {
            flushNotifications();
        }, 5000);
        return () => clearInterval(interval);
    }, [flushNotifications]);

    return (
        <NotificationContext.Provider value={{ notifications, addNotification, removeNotification, flushNotifications,notificationCountvalue,fetchNotifications ,notifcationvalue,updateNotificationStatus,markAllAsRead,shipdayResponse,              // 👈 Shipday data
            updateShipdayResponse}}>
            {children}
        </NotificationContext.Provider>
    );
}

// Custom hook for easy access to the notification context
export function useNotifications() {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
}